// extracted by mini-css-extract-plugin
module.exports = {"root":"noAuthAdmin_root__2MkEZ"};